module.exports = __webpack_public_path__ + "static/media/SerieVR.81f64b3b.jpg";